// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OmUTpBbGRcsnuZXO84vG{box-sizing:border-box;border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:6px;align-items:center;gap:4px;max-width:100%;padding:3px 7px;display:inline-flex;overflow:hidden}.OmUTpBbGRcsnuZXO84vG .ImCzHHxNRMNFXdkf_x1O,.OmUTpBbGRcsnuZXO84vG .xt2vARv3nTMcE1msZfyI{width:16px;height:16px}.OmUTpBbGRcsnuZXO84vG.WbmJWIHjTZ4FwN0rSeva{background:0 0;border:none;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `OmUTpBbGRcsnuZXO84vG`,
	"icon": `ImCzHHxNRMNFXdkf_x1O`,
	"closeIcon": `xt2vARv3nTMcE1msZfyI`,
	"chipWithoutBorder": `WbmJWIHjTZ4FwN0rSeva`
};
export default ___CSS_LOADER_EXPORT___;
